import { ReactNode } from 'react';
import styled from 'styled-components';

import SelectableButton from '@ui/atoms/SelectableButton';

import { BreakpointTypes, SpacingTypes } from '@folx-types/theme';

import theme from '@theme/FolxTheme';

export interface ISelectableButtonGrid {
	desktopColumns?: 1 | 2 | 3;
	mobileColumns?: 1 | 2;
	breakpoint?: BreakpointTypes;
	columnGap?: SpacingTypes;
	rowGap?: SpacingTypes;
	breakpointColumnGap?: SpacingTypes;
	breakpointRowGap?: SpacingTypes;
	children?: ReactNode;
}

const SelectableButtonGrid = styled.div<ISelectableButtonGrid>`
	display: grid;
	row-gap: ${({ rowGap }) => (rowGap ? theme.spacing![rowGap] : theme.spacing.sm)};
	column-gap: ${({ columnGap }) => (columnGap ? theme.spacing![columnGap] : theme.spacing.sm)};
	grid-template-columns: ${({ mobileColumns = 2 }) => `repeat(${mobileColumns}, 1fr)`};

	${SelectableButton} {
		width: 100%;
		&:nth-child(odd):last-of-type {
			grid-column-start: 1;
			grid-column-end: ${({ mobileColumns = 2 }) => mobileColumns + 1};
		}
	}

	@media ${({ breakpoint = 'laptop' }) => theme.responsive.breakpoints[breakpoint]} {
		row-gap: ${({ rowGap, breakpointRowGap }) =>
			breakpointRowGap
				? theme.spacing![breakpointRowGap]
				: rowGap
				? theme.spacing![rowGap]
				: theme.spacing.sm};
		column-gap: ${({ columnGap, breakpointColumnGap }) =>
			breakpointColumnGap
				? theme.spacing![breakpointColumnGap]
				: columnGap
				? theme.spacing![columnGap]
				: theme.spacing.sm};
		grid-template-columns: ${({ desktopColumns = 3 }) =>
			`repeat(${desktopColumns}, minmax(0, 1fr))`};

		${SelectableButton} {
			width: 100%;
			&:nth-child(odd):last-of-type {
				grid-column-start: auto;
				grid-column-end: auto;
			}
		}
	}
`;

export default SelectableButtonGrid;
